import { definePreset } from '@primeuix/themes';
import Material from '@primeuix/themes/material';

export const BsThemePreset = definePreset(Material, {
    semantic: {
        primary: {
            50: '{blue.50}',
            100: '{blue.100}',
            200: '{blue.200}',
            300: '{blue.300}',
            400: '{blue.400}',
            500: '{blue.500}',
            600: '{blue.600}',
            700: '{blue.700}',
            800: '{blue.800}',
            900: '{blue.900}',
            950: '{blue.950}'
        },
        secondary: {
            50: '{slate.50}',
            100: '{slate.100}',
            200: '{slate.200}',
            300: '{slate.300}',
            400: '{slate.400}',
            500: '{slate.500}',
            600: '{slate.600}',
            700: '{slate.700}',
            800: '{slate.800}',
            900: '{slate.900}',
            950: '{slate.950}'
        },
        colorScheme: {
            light: {
                surface: {
                    0: '#ffffff',
                    50: '{gray.50}',
                    100: '{gray.100}',
                    200: '{gray.200}',
                    300: '{gray.300}',
                    400: '{gray.400}',
                    500: '{gray.500}',
                    600: '{gray.600}',
                    700: '{gray.700}',
                    800: '{gray.800}',
                    900: '{gray.900}',
                    950: '{gray.950}'
                },
                formField: {
                    placeholderColor: '{gray.400}'
                }
            },
            dark: {
                surface: {
                    0: '#ffffff',
                    50: '#ececec',
                    100: '#dedfdf',
                    200: '#c4c4c6',
                    300: '#adaeb0',
                    400: '#97979b',
                    500: '#7f8084',
                    600: '#6a6b70',
                    700: '#55565b',
                    800: '#3f4046',
                    900: '#2c2c34',
                    950: '#16161d'
                },
                formField: {
                    placeholderColor: '{gray.500}',
                }
            }
        },
        formField: {
            paddingY: '0.5rem',
            sm: {
                paddingY: '0.3rem',
            },
            lg: {
                paddingY: '0.775rem',
            }
        }
    },
    components: {
        button: {
            root: {
                paddingY: '0.5rem',
                sm: {
                    paddingY: '0.3rem',
                },
                lg: {
                    paddingY: '0.775rem',
                }
            },
            colorScheme: {
                light: {
                    root: {
                        secondary: {
                            background: '{secondary.300}',
                            hoverBackground: '{secondary.400}',
                            activeBackground: '{secondary.500}',
                            borderColor: '{secondary.300}',
                            hoverBorderColor: '{secondary.400}',
                            activeBorderColor: '{secondary.500}',
                            color: '{secondary.800}',
                            hoverColor: '{secondary.900}',
                            activeColor: '{secondary.950}',
                            focusRing: {
                                color: '{secondary.800}',
                                shadow: 'none'
                            }
                        }
                    }
                },
                dark: {
                    root: {
                        secondary: {
                            background: '{secondary.700}',
                            hoverBackground: '{secondary.600}',
                            activeBackground: '{secondary.500}',
                            borderColor: '{secondary.700}',
                            hoverBorderColor: '{secondary.600}',
                            activeBorderColor: '{secondary.500}',
                            color: '{secondary.200}',
                            hoverColor: '{secondary.100}',
                            activeColor: '{secondary.0}',
                            focusRing: {
                                color: '{secondary.200}',
                                shadow: 'none'
                            }
                        }
                    }
                }
            }
        }
    }
});